import { Box } from "@mui/material";
import { getStatusText } from "@/utils";
import { v4 } from "uuid";

export const config = (data: any) => {
  if (!data) return [];
  const { qual, proposal, final_presentation, other } = data;

  const style = {
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };
  return [
    {
      id: v4(),
      renderer: <Box sx={style}>{getStatusText("Qual", qual)}</Box>,
      status: { present: qual.present, verified: qual.verified },
    },
    {
      id: v4(),
      renderer: <Box sx={style}>{getStatusText("Proposal", proposal)}</Box>,
      status: { present: proposal.present, verified: proposal.verified },
    },
    {
      id: v4(),
      renderer: (
        <Box sx={style}>
          {getStatusText("Project Report", final_presentation)}
        </Box>
      ),
      status: {
        present: final_presentation.present,
        verified: final_presentation.verified,
      },
    },
    {
      id: v4(),
      renderer: <Box sx={style}>{getStatusText("Other", other)}</Box>,
      status: {
        present: other.present,
        verified: other.verified,
      },
    },
  ];
};
